import type { RequestInfo } from '@ember-data/request';
import { buildBaseURL, type QueryUrlOptions } from '@warp-drive/utilities';
import { SkipCache } from '@warp-drive/core-types/request';

const genericRelationshipsUrl = (path?: string) => {
  const opts: QueryUrlOptions = {
    identifier: { type: 'generic-relationships' },
    op: 'query',
    resourcePath: 'generic-relationships',
  };
  const base = buildBaseURL(opts);
  return path ? `${base}/${path.replace(/^\/+/, '')}` : base;
};

const userRelationshipsUrl = (path?: string) => {
  const opts: QueryUrlOptions = {
    identifier: { type: 'user-relationships' },
    op: 'query',
    resourcePath: 'user-relationships',
  };
  const base = buildBaseURL(opts);
  return path ? `${base}/${path.replace(/^\/+/, '')}` : base;
};

export interface DelegateGovernorPayload {
  delegateGovernorId: string;
  delegateGovernorType: string;
  expiresDate: string;
  governorId: string;
  governorType: string;
}

/** POST /generic-relationships/delegate-governor */
export function delegateGovernorRelationshipRequest(payload: DelegateGovernorPayload): RequestInfo {
  const body = JSON.stringify({
    'delegate-governor-id': payload.delegateGovernorId,
    'delegate-governor-type': payload.delegateGovernorType,
    'delegate-expires-after': payload.expiresDate,
    'governor-id': payload.governorId,
    'governor-type': payload.governorType,
  });
  return {
    url: genericRelationshipsUrl('delegate-governor'),
    method: 'POST',
    body,
    cacheOptions: { [SkipCache]: true },
  };
}

/** DELETE /generic-relationships/:roleId/revoke */
export function deleteJurisdictiveRelationshipRequest(roleId: string): RequestInfo {
  return {
    url: genericRelationshipsUrl(`${roleId}/revoke`),
    method: 'DELETE',
    cacheOptions: { [SkipCache]: true },
  };
}

/** DELETE /user-relationships/:roleId/revoke */
export function revokeUserRelationshipRequest(roleId: string): RequestInfo {
  return {
    url: userRelationshipsUrl(`${roleId}/revoke`),
    method: 'DELETE',
    cacheOptions: { [SkipCache]: true },
  };
}
